import { Row, RenderConfig, TextInput, SelectInput } from 'commons-ui';
import { FORM_FIELD_KEYS, PERMISSION_TYPE_OPTIONS, PLACEHOLDERS } from './constants';

export const DEFAULT_CONFIG = {
	pageDetails: {
		pageNo: 1,
		pageSize: 20
	}
};

export const FORM_FIELD_CONFIG = {
	[FORM_FIELD_KEYS.DESCRIPTION]: new RenderConfig()
		.setName('description')
		.setLabel('Description')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true },
			isHidden: { create: false },
			required: true,
			placeholder: PLACEHOLDERS.DESCRIPTION
		}),

	[FORM_FIELD_KEYS.PERMISSION_TYPE]: new RenderConfig()
		.setName('permissionType')
		.setLabel('Permission Type')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true },
			isHidden: { create: false },
			required: true,
			options: PERMISSION_TYPE_OPTIONS,
			placeholder: PLACEHOLDERS.PERMISSION_TYPE,
			clearable: false,
			searchable: false,
			defaultValue: null,
			onChange: (value: any, onChange: (value: any) => void) => {
				onChange(value?.id || null);
			}
		})
};

export const FORM_LAYOUT_CONFIG = [new Row(FORM_FIELD_KEYS.DESCRIPTION), new Row(FORM_FIELD_KEYS.PERMISSION_TYPE)];

export const getStatusColor = (status: string, colorMap: Record<string, string>): string => {
	return colorMap[status] || colorMap.DEFAULT;
};
